<template>
  <div class="navMargin">
    <NavBar :scroll-padding="true" :transparent-on-top="true"></NavBar>
    <div style="margin-left: 5%; margin-right: 5%;">
      <h1>{{ content.title }}</h1>
      <p :key="line.id" v-for="line in content.page.split('\n')">{{ line }}</p>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import Footer from "../views/Footer";
import NavBar from "../components/NavBar";

export default {
  name: "PageView",
  components: { Footer, NavBar },
  data() {
    return {
      content: {
        title: "",
        page: ""
      }
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: '#000',
      color: '#fff',
      text: 'Cargando...'
    });
    axios
        .get('https://api.videnti.co/pages/getPage/' + this.$route.params.page)
        .then(res => {
          if (!res.data) {
            // window.location = 'https://videnti.co/?error=PAGE_DOES_NOT_EXIST';
            this.$router.replace({ name: "notfound" })
            return;
          }
          this.content.title = res.data.title;
          this.content.page = res.data.content.replaceAll("\\n", "\n");
        });
    loading.close();
  },
  metaInfo() {
    return {
      title: this.content.title,
      titleTemplate: '%s - Videnti',
      htmlAttrs: {
        lang: 'es'
      },
      meta: [
        { charset: 'utf8' }
      ]
    }
  }
}
</script>

<style scoped>

</style>
